export default __webpack_public_path__ + "media/slack-logo.7c050.png";